import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const RateCardCreationModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=lNNpZ4aKsDY&feature=youtu.be&ab_channel=apadua" />
);

export default RateCardCreationModal;
